export class SqlColumnDefinition {

    public Name: string = "";
    public DataTypeNameWithSize: string = "";
    public IsNullable: boolean = false;
    public IsUnique: boolean = false;
    public DefaultValue: string | null = null;
    public ForeignKeyFullColumnName: string = "";
}
